import { UserAuthErrorCode } from '../types'
import { PASSWORD_RESET_FIELD_MESSAGES } from '../constants/password'
import { userAuthErrorClass } from './userAuthErrorClass'

const EXPECTED_USER_AUTH_CODES: string[] = [
    UserAuthErrorCode.PASSWORD_RESET_INVALID_TOKEN,
    UserAuthErrorCode.PASSWORD_RESET_OUTSIDE_GEOFENCE,
    UserAuthErrorCode.PASSWORD_RESET_RATE_LIMITED,
]

export function hasOnlyMappedFieldErrors(errors?: Record<string, unknown>): errors is Record<string, unknown> {
    const fields = Object.keys(errors ?? {})

    return fields.length > 0 && fields.every(field => field in PASSWORD_RESET_FIELD_MESSAGES)
}

export const passwordResetErrorClass = userAuthErrorClass(
    EXPECTED_USER_AUTH_CODES,
    error => error.status === 429 || hasOnlyMappedFieldErrors(error.data?.errors)
)
